module.exports = require("./kk.d.ts");